function getRandomHexColor() {
  return `#${Math.floor(Math.random() * 16777215)
    .toString(16)
    .padStart(6, "0")}`;
}

export const generateColorArray = (size: number) => {
  const COLORS: string[] = [
    "#4A90E2",
    "#D0021B",
    "#7ED321",
    "#F5A623",
    "#8B572A",
    "#BD10E0",
    "#417505",
    "#F8E71C",
    "#50E3C2",
    "#B8E986",
    "#9013FE",
    "#FF6F61",
    "#2D9CDB",
    "#27AE60",
    "#EB5757",
    "#F2994A",
    "#6C5CE7",
    "#00BCD4",
    "#FF9800",
    "#009688",
    "#9C27B0",
    "#E91E63",
    "#3F51B5",
    "#CDDC39",
    "#03A9F4",
    "#FF5722",
    "#C2185B",
    "#4B7F8C",
    "#627C85",
    "#6E6A75",
    "#83677B",
    "#775C67",
    "#5C677D",
    "#697D7C",
    "#7B8F8A",
    "#72888A",
    "#6C737E",
    "#5E6073",
    "#5C6B73",
    "#76828B",
    "#62767D",
    "#8A8D94",
    "#7B7088",
    "#766C82",
    "#6D798C",
    "#6C8B8C",
    "#8B8C7A",
    "#607D84",
    "#7A7E99",
    "#85958C",
    "#758E8C",
    "#908D8F",
    "#7A8690",
    "#6E7F8D",
    "#787A8D",
    "#6F8C85",
    "#848E95",
    "#738B94",
    "#79818C",
    "#827880",
    "#73777E",
    "#607080",
    "#798291",
    "#858BAA",
    "#768A9C",
    "#687D8E",
    "#768B9F",
    "#7F86A4",
    "#8C90A1",
    "#706F7A",
    "#7C8F99",
    "#5F6D78",
    "#7A96A1",
    "#718B95",
    "#667C8A",
    "#829B96",
    "#7A8D8A",
    "#7B7F89",
    "#728294",
    "#6E7D91",
    "#84949F",
    "#778A91",
    "#70898E",
    "#697B8B",
    "#869D9E",
    "#788C91",
    "#7D878B",
    "#708393",
    "#728D96",
    "#809094",
    "#889097",
    "#69707A",
    "#78848E",
    "#767F84",
    "#788E99",
    "#8A9B9D",
    "#75838D",
    "#6D7983",
    "#7A848D",
    "#6A7B7C",
    "#798390",
    "#818D91",
    "#829CA0",
    "#707E8C",
    "#8C9B99",
    "#778C8E",
    "#708091",
    "#728E99",
    "#7F929B",
    "#768C95",
    "#798A96",
    "#75848D",
    "#798B92",
    "#7B8A95",
    "#85979C",
    "#7D8C94",
    "#687A7F",
    "#829090",
    "#6F8186",
    "#6A7C82",
    "#7A8F95",
    "#7F8B90",
    "#76888F",
    "#70838A",
    "#6D7D83",
    "#76888C",
    "#788F91",
  ];

  if (size > COLORS.length) {
    return Array.from({ length: size }, getRandomHexColor);
  } else {
    return COLORS;
  }
};

export const getNumberOfALetter = (letter: string) => {
  return letter.toUpperCase().charCodeAt(0) - 64;
};

export const getColor = (letter: string) => {
  const allColors = generateColorArray(26);
  return allColors[getNumberOfALetter(letter)];
};
